var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 4.875H3.025C2.91891 4.875 2.81717 4.91936 2.74216 4.99832C2.66714 5.07729 2.625 5.18438 2.625 5.29605V19.6118C2.625 19.9469 2.75143 20.2681 2.97647 20.505C3.20152 20.7419 3.50674 20.875 3.825 20.875H21.425C21.7433 20.875 22.0485 20.7419 22.2735 20.505C22.4986 20.2681 22.625 19.9469 22.625 19.6118V5.29605C22.625 5.18438 22.5829 5.07729 22.5078 4.99832C22.4328 4.91936 22.3311 4.875 22.225 4.875ZM21.197 5.71711L12.625 13.9876L4.053 5.71711H21.197ZM21.425 20.0329H3.825C3.71891 20.0329 3.61717 19.9885 3.54216 19.9096C3.46714 19.8306 3.425 19.7235 3.425 19.6118V6.25289L12.355 14.875C12.4287 14.946 12.5251 14.9854 12.625 14.9854C12.7249 14.9854 12.8213 14.946 12.895 14.875L21.825 6.25289V19.6118C21.825 19.7235 21.7829 19.8306 21.7078 19.9096C21.6328 19.9885 21.5311 20.0329 21.425 20.0329Z",
    fill: "#AEB3B6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.af1bde29500496ae51a9be65dd42d890.svg";